import BootstrapActions from './bootstrap';
import CartActions from './cart';
import ErrorActions from './error';
import HelpActions from './help';
import JoyrideActions from './joyride';
import LoginActions from './login';
import OfferActions from './offer';
import OrderActions from './order';
import UiActions from './ui';
import UserActions from './user';
import SiteActions from './sites';

export default {
    ...BootstrapActions.types,
    ...CartActions.types,
    ...ErrorActions.types,
    ...HelpActions.types,
    ...JoyrideActions.types,
    ...LoginActions.types,
    ...OfferActions.types,
    ...OrderActions.types,
    ...UiActions.types,
    ...UserActions.types,
    ...SiteActions.types,
};



// WEBPACK FOOTER //
// ./app/actions/index.js